import { usePeriodoInventario } from "../../../../contexto/provider/InventarioPeriodosContext.js";
import { capitalizar } from "../../../../../utils/capitalizar.js";

import BotonAccion from "../../../../componentsUI/formularios/button/BotonAction.js";
import SelectGenerico from "../../../../componentsUI/formularios/selector/selectorGenerico.js";

export default function InventarioInicialForm({
  periodoId,
  setPeriodoId,
  tipoInventario,
  setTipoInventario,
  loading,
  mensaje,
  onCrearInventario,
  onActualizarInventario,
}) {

  const { periodos } = usePeriodoInventario();

  const tiposInventarioOpciones = [
    { id: 1, nombre: "Fisico" },
    { id: 2, nombre: "Virtual" },
  ];

  return (

    <>
      {/* Acciones */}
      <div className="contenedor-grupo">

        <BotonAccion onClick={onCrearInventario} disabled={loading}>
          {loading ? "Creando..." : "Crear Inventario"}
        </BotonAccion>

        <BotonAccion onClick={onActualizarInventario} disabled={loading}>
          Actualizar Inventario
        </BotonAccion>

      </div>

      {/* Formulario */}
      <div className="inventario-form">

        <div className="campo campo-periodo">

          <SelectGenerico
            id="select-periodo"
            label="Seleccionar periodo"
            value={periodoId}
            onChange={setPeriodoId}
            options={periodos}
            getOptionValue={(p) => p.id}
            getOptionLabel={(p) =>
              `${p.anio}-${p.mes} - ${capitalizar(p.estado)}`
            }
          />

          <SelectGenerico
            id="select-tipo"
            label="Seleccionar tipo de inventario"
            value={tipoInventario}
            onChange={setTipoInventario}
            options={tiposInventarioOpciones}
            getOptionValue={(tipo) => tipo.id}
            getOptionLabel={(tipo) => capitalizar(tipo.nombre)}
          />

        </div>

        {mensaje && (
          <div className="tabla-mensaje">
            <p>{mensaje}</p>
          </div>
        )}

      </div>
    </>
  );
}